import { Controller } from "@hotwired/stimulus"
import { AsYouType, getCountries, getCountryCallingCode, isValidPhoneNumber } from 'libphonenumber-js'

export default class extends Controller {
  static targets = ["input", "countryCode"]
  static values = {
    countryCode: String
  }

  connect() {
    console.log("Phone mask controller connected")
    const rawCountryCode = this.countryCodeTarget.value || '+1'
    this.countryCodeValue = this.convertToCountryCode(rawCountryCode)
    this.validateOnPageLoad()
  }

  convertToCountryCode(callingCode) {
    const callingCodeNumber = callingCode.replace('+', '')
    const countries = getCountries()
    const country = countries.find(country => {
      const countryCallingCode = getCountryCallingCode(country)
      return countryCallingCode === callingCodeNumber
    })
    return country || 'US'
  }

  format(event) {
    const input = event.target.value.replace(/\D/g, '')
    const countryCode = this.convertToCountryCode(this.countryCodeTarget.value || '+1')
    
    // Create new AsYouType instance with country code
    const formatter = new AsYouType(countryCode)
    
    // Formatting handles national number without country code
    event.target.value = formatter.input(input)
  }

  countryCodeChanged(event) {
    const newCountryCode = this.convertToCountryCode(event.target.value)
    this.countryCodeValue = newCountryCode
    
    // Reformat number with new country code
    if (this.inputTarget.value) {
      const cleanInput = this.inputTarget.value.replace(/\D/g, '')
      this.inputTarget.value = ''
      this.format({ target: this.inputTarget })
    }
  }

  validateOnInput(event) {
    console.log("Validating on input")
    const input = event.target.value.replace(/\D/g, '')
    const countryCode = this.convertToCountryCode(this.countryCodeTarget.value || '+1')
    
    if (!isValidPhoneNumber(input, countryCode)) {
      console.log("Invalid phone number")
      event.target.setCustomValidity('Please enter a valid phone number')
      event.target.reportValidity()
    } else {
      event.target.setCustomValidity('')
    }
  }

  validateOnPageLoad() {
    // Only validate if the input is not empty
    if (!this.inputTarget.value) return

    const input = this.inputTarget.value.replace(/\D/g, '')
    const countryCode = this.convertToCountryCode(this.countryCodeTarget.value || '+1')

    if (!isValidPhoneNumber(input, countryCode)) {
      this.inputTarget.setCustomValidity('Please enter a valid phone number')
      this.inputTarget.reportValidity()
    }
  }
} 
